import { Link } from 'react-router-dom';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import FloatingContact from '../../components/feature/FloatingContact';
import { useEffect } from 'react';

const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <FloatingContact />

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center">
        <div className="absolute inset-0 z-0">
          <img
            src="https://public.readdy.ai/ai/img_res/b7646018656040ced76b514999e33780.jpg"
            alt="Modern Architecture"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/40 to-black/20"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-8 lg:px-20 w-full">
          <div className="max-w-2xl">
            <p className="text-white/80 text-xs uppercase tracking-[0.3em] mb-4 md:mb-6 font-sans">
              Mimar
            </p>
            <h1 className="font-serif text-4xl md:text-6xl lg:text-7xl text-white mb-6 md:mb-8 leading-tight">
              Levent Atalay
            </h1>
            <p className="text-white/90 text-base md:text-lg lg:text-xl font-sans font-light leading-relaxed mb-8 md:mb-12 max-w-xl">
              Mekân ile insan arasındaki ilişkiyi kuran, estetik sadelik ve fonksiyonel çözümlerle zamansız mimari tasarımlar
            </p>
            <Link
              to="/mimari-yaklasim"
              className="inline-block border border-white text-white px-6 py-3 md:px-8 md:py-3 text-xs md:text-sm tracking-wide hover:bg-white hover:text-dark-gray transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Mimari Yaklaşımı Keşfet
            </Link>
          </div>
        </div>
      </section>

      {/* Philosophy Section */}
      <section className="bg-cream py-16 md:py-24 lg:py-32">
        <div className="max-w-7xl mx-auto px-6 md:px-8 lg:px-20">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12">
            <div className="md:col-span-3">
              <p className="text-xs uppercase tracking-[0.3em] text-mid-gray font-sans">
                Mimari Felsefe
              </p>
            </div>
            <div className="md:col-span-9">
              <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl text-dark-gray leading-relaxed max-w-3xl">
                Mimarlık, yalnızca yapı üretimi değil; mekân ile insan arasındaki derin ilişkiyi kuran bir disiplindir. Her proje, işlev ve estetiğin mükemmel dengesini arar.
              </h2>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Projects Preview */}
      <section className="bg-light-gray py-16 md:py-20 lg:py-24">
        <div className="max-w-7xl mx-auto px-6 md:px-8 lg:px-20">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-dark-gray mb-3 md:mb-4">
              Seçili Projeler
            </h2>
            <p className="text-mid-gray font-sans text-sm md:text-base max-w-xl mx-auto px-4">
              Her proje, mimari kimliği güçlü ve zamansız mekânlar yaratma vizyonunun bir yansımasıdır
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            <Link to="/hizmetler/konut-projeleri" className="bg-dark-gray rounded-xl md:rounded-2xl overflow-hidden group cursor-pointer">
              <div className="relative h-64 md:h-72 lg:h-80 overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Luxury%20modern%20residential%20villa%20exterior%20with%20minimalist%20white%20architecture%2C%20large%20glass%20windows%2C%20geometric%20clean%20lines%2C%20surrounded%20by%20landscaped%20garden%2C%20evening%20ambient%20lighting%2C%20professional%20architectural%20photography%2C%20ultra%20high%20quality%2C%20contemporary%20design%2C%20sophisticated%20elegance&width=800&height=900&seq=proj-res-001&orientation=portrait"
                  alt="Konut Projesi"
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-6 md:p-8">
                <h3 className="font-sans text-lg md:text-xl text-white mb-2 md:mb-3 font-medium">
                  Konut Projeleri
                </h3>
                <p className="text-gray-400 text-xs md:text-sm leading-relaxed mb-4 md:mb-6">
                  Minimalist tasarım anlayışıyla doğal ışık ve mekân akışını ön planda tutan konut tasarımı
                </p>
                <span className="inline-block border border-white text-white px-5 py-2 md:px-6 md:py-3 text-xs tracking-wide hover:bg-white hover:text-dark-gray transition-all duration-300 whitespace-nowrap">
                  Detayları Gör
                </span>
              </div>
            </Link>

            <Link to="/hizmetler/ticari-alanlar" className="bg-white rounded-xl md:rounded-2xl overflow-hidden group cursor-pointer">
              <div className="relative h-56 md:h-60 lg:h-64 overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Contemporary%20commercial%20office%20building%20interior%20with%20open%20space%20design%2C%20natural%20wood%20elements%2C%20minimalist%20furniture%2C%20abundant%20natural%20light%20through%20floor%20to%20ceiling%20windows%2C%20modern%20professional%20workspace%2C%20clean%20aesthetic%2C%20neutral%20color%20palette%2C%20architectural%20photography&width=800&height=600&seq=proj-com-001&orientation=landscape"
                  alt="Ticari Proje"
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-6 md:p-8">
                <div className="flex items-center gap-2 mb-2 md:mb-3">
                  <i className="ri-building-line text-dark-gray text-sm"></i>
                  <span className="text-xs text-mid-gray uppercase tracking-wide">Ticari</span>
                </div>
                <h3 className="font-sans text-base md:text-lg text-dark-gray mb-2 font-semibold">
                  Ticari Alanlar
                </h3>
                <p className="text-mid-gray text-xs leading-relaxed">
                  Fonksiyonel ve estetik çözümlerle modern çalışma alanı
                </p>
              </div>
            </Link>

            <Link to="/hizmetler/ozel-projeler" className="bg-white rounded-xl md:rounded-2xl overflow-hidden group cursor-pointer">
              <div className="relative h-56 md:h-60 lg:h-64 overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20boutique%20hotel%20lobby%20interior%20with%20sophisticated%20minimalist%20design%2C%20luxurious%20materials%2C%20marble%20surfaces%2C%20ambient%20lighting%2C%20contemporary%20furniture%2C%20high%20ceiling%2C%20refined%20atmosphere%2C%20professional%20interior%20photography%2C%20premium%20quality%2C%20neutral%20tones&width=800&height=600&seq=proj-hotel-001&orientation=landscape"
                  alt="Özel Proje"
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-6 md:p-8">
                <div className="flex items-center gap-2 mb-2 md:mb-3">
                  <i className="ri-hotel-line text-dark-gray text-sm"></i>
                  <span className="text-xs text-mid-gray uppercase tracking-wide">Özel</span>
                </div>
                <h3 className="font-sans text-base md:text-lg text-dark-gray mb-2 font-semibold">
                  Özel Projeler
                </h3>
                <p className="text-mid-gray text-xs leading-relaxed">
                  Lüks ve konfor dengesinde özgün mekân deneyimi
                </p>
              </div>
            </Link>
          </div>

          <div className="text-center mt-10 md:mt-12">
            <Link
              to="/projeler"
              className="inline-block border border-dark-gray text-dark-gray px-6 py-3 md:px-8 md:py-3 text-xs md:text-sm tracking-wide hover:bg-dark-gray hover:text-white transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Tüm Projeleri Görüntüle
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Home;
